import React, { ReactNode } from 'react'
import { Col, Container, Row } from '@paypalcorp/pp-react'
import styles from './CompGrid.module.css'
import Image from '../../../templates/Image'
//import data from './data'

interface CompGridProps {
  dataKey: string
  children: ReactNode | ReactNode[]
}

const data = [
  {
    title: 'Client and server side integrations',
    standard: true,
    advance: true,
  },
  {
    title: 'Accept PayPal, Venmo, and Pay Later offers',
    standard: true,
    advance: true,
  },
  {
    title: 'Accept alternative payment methods',
    standard: true,
    advance: true,
  },
  {
    title: 'One-time sales transactions',
    standard: true,
    advance: true,
  },
  {
    title: 'Auth and capture transactions',
    standard: true,
    advance: true,
  },
  {
    title: 'Void and refunds',
    standard: true,
    advance: true,
  },
  {
    title: 'Advanced credit and debit card payments',
    standard: false,
    advance: true,
  },
  {
    title: 'Custom user experience',
    standard: false,
    advance: true,
  },
  {
    title: 'Customizable fraud protection tools',
    standard: false,
    advance: true,
  },
]

const columns = [
  { key: 'title', label: '' },
  { key: 'standard', label: 'PayPal Checkout' },
  { key: 'advance', label: 'Expanded Checkout' },
]

export const CompGrid: React.FC<CompGridProps> = ({ children, dataKey }) => {
  //return <div>Visible compo grid</div>
  // if (!dataMap.hasOwnProperty(dataKey)) {
  //   console.error('Invalid data key given to card component', dataKey)
  //   return null
  // }

  // const { heading, description, image } = dataMap[dataKey]

  return (
    <div className={styles.compContainer}>
      <h1>Compare our packaged solutions</h1>
      <p>Features included in PayPal Checkout and Expanded Checkout.</p>
      <div className={styles.container}>
        <div className={styles.header}>
          {/* <h2>{heading}</h2>
        <p>{description}</p> */}
        </div>
        <table className={styles.tableWrapper}>
          <thead>
            <tr>
              {columns.map((column, key: React.Key | null | undefined) => (
                <th key={key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, key: React.Key | null | undefined) => (
              <tr key={key}>
                <td>{item.title}</td>
                <td>
                  {item.standard ? (
                    <img
                      src="https://www.paypalobjects.com/ppdevdocs/multipartyimages/checkmark.png"
                      alt="standard"
                    />
                  ) : null}
                </td>
                <td>
                  {item.advance ? (
                    <img
                      src="https://www.paypalobjects.com/ppdevdocs/multipartyimages/checkmark.png"
                      alt="advance"
                    />
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
